export default "__VITE_PUBLIC_ASSET__841ee8e0__"